import { FeatureFlag } from "PFTypes";
import { useCallback } from "react";

import { isReviewerUnbiased, UnbiasedReviewer } from "../helpers/is_reviewer_unbiased";
import useIsFeatureEnabled from "../helpers/use_is_feature_enabled";
import { useCurrentProfile } from "./queries/profile";

export function useIsUnbiasedMode(): (reviewers?: UnbiasedReviewer[] | null) => boolean;

export function useIsUnbiasedMode(reviewers: UnbiasedReviewer[] | null | undefined): boolean;

export function useIsUnbiasedMode(
  ...args: [] | [UnbiasedReviewer[] | null | undefined]
): ((reviewers?: UnbiasedReviewer[] | null) => boolean) | boolean {
  const isFeatureEnabled = useIsFeatureEnabled(FeatureFlag.UnbiasedAllocation);
  const { data: currentProfile } = useCurrentProfile();

  const checkUnbiasedMode = useCallback(
    (reviewers?: UnbiasedReviewer[] | null): boolean => {
      if (!isFeatureEnabled || !currentProfile) {
        return false;
      }
      return isReviewerUnbiased(reviewers, currentProfile.id);
    },
    [isFeatureEnabled, currentProfile]
  );

  if (args.length > 0) {
    return checkUnbiasedMode(args[0]);
  }

  return checkUnbiasedMode;
}
